/// <amd-module name="Wit/QueriesHub/Charts/Common/ChartCommon" />

import * as ChartColor from "Tfs/Charting/ChartColor";
import { IDataTableData } from "Tfs/Charting/ChartContracts";
import { ColorConfiguration } from "Tfs/Charting/Contracts/Reporting";

export const scope = "WorkitemTracking.Queries";

export interface ITransformQueryData {
    data: IDataTableData[];
    transform: any;
}

export interface ITransformQueryResults {
    result: ITransformQueryData[];
}

export function getColorDictionary(userColors: ColorConfiguration[] | undefined) {
    const featureColorProvider = ChartColor.getFeatureColorProvider(scope);
    const colorDictionary = ChartColor.ColorDictionary.fromColorEntries(featureColorProvider, userColors);
    return colorDictionary;
}
